// import 'core-js'
// import 'core-js/shim'
// import '@babel/polyfill'

import vuetify from "./plugins/vuetify";
import "@/plugins/composition-api";
import "@/plugins/vuetify-tosti";
import "@/plugins/moment";
import "@/plugins/okta";
import "@/plugins/context";
import "@/plugins/smartlook";
import "@/plugins/casl";
import "@/plugins/vuera";
import "@/plugins/filters";

import Vue from "vue";
import router from "./router/router";
import { store } from "./store";

import "@/scss/vuetify-overrides.scss";
import "@ciao/components/src/assets/fonts/index.css";
import "@mdi/font/css/materialdesignicons.css";
import "leaflet/dist/leaflet.css";
import { createPinia, PiniaPlugin } from "pinia";
import App from "./App.vue";

Vue.config.productionTip = false;

Vue.use(PiniaPlugin);

const pinia = createPinia();

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
    pinia,
}).$mount("#app");
